import Vue from 'vue';
import store from './lib/Store.js';
import router from './router.js';
import {ValidationObserver, ValidationProvider} from 'vee-validate';

import '/node_modules/froala-editor/css/froala_editor.pkgd.min.css';

import App from './App.vue';

/* Cookie Popups */
import CookiePopups from './components/CookiePopups.vue';
import BottomCheckboxes from './components/cookie-popups/BottomCheckboxes.vue';
import SimpleBottom from './components/cookie-popups/SimpleBottom.vue';
import FriendlyPopup from './components/cookie-popups/FriendlyPopup.vue';
import BlockingPopup from './components/cookie-popups/BlockingPopup.vue';

/* Blog Feed */
import BlogFeed from './components/BlogFeed.vue';

/* Menu Components */
import MenuSearch from './components/MenuSearch.vue';
import UserSearch from './components/UserSearch.vue';
import FullScreenSearch from './components/FullScreenSearch.vue';

import DateTimePickerWrapper from './components/DateTimePickerWrapper.vue';
import MobileAppMessage from './components/MobileAppMessage.vue';

import AppearLoggedIn from './components/AppearLoggedIn.vue';

/* Poll components */
import PollMaker from './components/PollMaker.vue';
import PollMakerTrigger from './components/PollMakerTrigger.vue';
import Poll from './components/poll/Poll.vue';
import PollEditButton from './components/poll/PollEditButton.vue';
import PollMultipleChoice from './components/poll/formElements/PollMultipleChoice.vue';
import PollQuestion from './components/poll/formElements/PollQuestion.vue';

/* Group components */
import GroupRules from './components/groups/GroupRules';
import GroupAttachments from './components/groups/GroupAttachments';

/* Quiz components */
import Quiz from './components/quiz/Quiz.vue';
import QuizStart from './components/quiz/formElements/QuizStart.vue';
import QuizBottom from './components/quiz/formElements/QuizBottom.vue';
import QuizQuestion from './components/quiz/formElements/Question.vue';
import QuizTop from './components/quiz/formElements/QuizTop.vue';
import MultipleChoice from './components/quiz/formElements/MultipleChoice.vue';
import TrueFalse from './components/quiz/formElements/TrueFalse.vue';
import FreeForm from './components/quiz/formElements/FreeForm.vue';
import QuestionMedia from './components/quiz/formElements/QuestionMedia.vue';
import Score from './components/quiz/formElements/Score.vue';
import QuizTimer from './components/quiz/formElements/QuizTimer.vue';
import QuizEnd from './components/quiz/formElements/QuizEnd.vue';
import QuizTimeRanOut from './components/quiz/formElements/TimeRanOut.vue';

/* Analytics tracker */
import Tracker from './components/shared/Tracker.vue';

/* e-learning */
import Finished from './components/e-learning/Finished.vue';
import ContentLesson from './components/e-learning/ContentLesson.vue';

/* messages */
import Messages from './views/messages/Index.vue';

/* huddle editor */
import HuddleEditorImages from './components/HuddleEditorImages.vue';
import HuddleEditorV2 from './components/HuddleEditorV2.vue';
import HuddleEditorV2Main from './components/HuddleEditorV2Main.vue';

/* Plugins */
import Settings from './lib/plugins/settings';
import ProfileEmailField from './components/ProfileEmailField.vue';
import Echo from 'laravel-echo';

/* Form components */
import FormRow from './components/ui/input/FormRow.vue';
import FormField from './components/ui/input/FormField.vue';
import FormInput from './components/ui/input/FormInput';

/* Onboarding components */
import OnboardingModals from './components/onboarding/OnboardingModals.vue';

Vue.component('app', App);

/* Vee-validate components */
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

//only simplebottom and blockingpopup are currently active
Vue.component('cookie-popups', CookiePopups);
Vue.component('bottomcheckboxes', BottomCheckboxes);
Vue.component('simplebottom', SimpleBottom);
Vue.component('friendlypopup', FriendlyPopup);
Vue.component('blockingpopup', BlockingPopup);

Vue.component('blogfeed', BlogFeed);

/* Menu components */
Vue.component('menu-search', MenuSearch);
Vue.component('full-screen-search', FullScreenSearch);

Vue.component('date-time-picker-wrapper', DateTimePickerWrapper);

Vue.component('mobile-app-message', MobileAppMessage);

Vue.component('appear-logged-in', AppearLoggedIn);

/* Poll components */
Vue.component('poll-maker', PollMaker);
Vue.component('poll-maker-trigger', PollMakerTrigger);
Vue.component('poll', Poll);
Vue.component('poll-edit-button', PollEditButton);
Vue.component('poll_multiple_choice', PollMultipleChoice);
Vue.component('poll-question', PollQuestion);

/* Quiz components */
Vue.component('quiz', Quiz);
Vue.component('quiz-start', QuizStart);
Vue.component('quiz-bottom', QuizBottom);
Vue.component('quiz-question', QuizQuestion);
Vue.component('quiz-top', QuizTop);
Vue.component('multiple_choice', MultipleChoice);
Vue.component('true_false', TrueFalse);
Vue.component('free_form', FreeForm);
Vue.component('question-media', QuestionMedia);
Vue.component('score', Score);
Vue.component('quiz-timer', QuizTimer);
Vue.component('quiz-end', QuizEnd);
Vue.component('quiz-time-ran-out', QuizTimeRanOut);

/* Group components */
Vue.component('group-rules', GroupRules);
Vue.component('group-attachments', GroupAttachments);

/*  Analytics Tracker */
Vue.component('tracker', Tracker);

/*  E-learning */
Vue.component('e-learning-finished', Finished);
Vue.component('content-lesson', ContentLesson);

Vue.component('user-search', UserSearch);

/* messages */
Vue.component('messages', Messages);

/* Form components */
Vue.component('form-row', FormRow);
Vue.component('form-field', FormField);
Vue.component('form-input', FormInput);

/* Onboarding components */
Vue.component('onboarding-modals', OnboardingModals);

/* Huddle Editor */
Vue.component('huddle-editor-images', HuddleEditorImages);
Vue.component('huddle-editor-v2', HuddleEditorV2);
Vue.component('huddle-editor-v2-main', HuddleEditorV2Main);
Vue.component('profile-email-field', ProfileEmailField);

window.pluralize = require('pluralize');

require('./bootstrap');

Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;

const app = new Vue({
	el: '#vue-wrapper',
	store,
	router,

	created() {
		window.Pusher = require('pusher-js');
		window.Echo = new Echo({
			broadcaster: 'pusher',
			key: `${process.env.VUE_APP_SOKETI_KEY}`,
			cluster: 'eu',
			wsHost: `${process.env.VUE_APP_SOKETI_HOST}`,
			wssHost: `${process.env.VUE_APP_SOKETI_HOST}`,
			encrypted: true,
			forceTLS: true,
		});
	},

	mounted() {
		Vue.use(Settings, this.$store);

		// //get settings
		axios.get('/api/v3/settings')
			.then((response) => {
				this.$store.commit('setSettings', response.data.data);
				this.$store.commit('setPlugins', response.data.data.plugins);
			});
		//
		// //get translations
		axios.get('/api/v3/settings?group=translations')
			.then((response) => {
				this.$store.commit('setTranslations', response.data);
			});
	},
});

window.Store = store;
